import { InlineSVGModule } from 'ng-inline-svg-2';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeaderboardTrialInvitesPopupComponent } from './leaderboard-trial-invites-popup.component';
import { FormsModule } from '@app/shared/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderModule } from '@app/shared';
import { DataTestModule } from '@app/shared/directive/data-test';

@NgModule({
    declarations: [LeaderboardTrialInvitesPopupComponent],
    imports: [CommonModule, InlineSVGModule, FormsModule, ReactiveFormsModule, LoaderModule, TranslateModule, DataTestModule],
    exports: [LeaderboardTrialInvitesPopupComponent],
})
export class LeaderboardTrialInvitesPopupModule {}
